import { render } from "./PoultryDataForm.vue?vue&type=template&id=b9fb2a52&scoped=true&ts=true"
import script from "./PoultryDataForm.vue?vue&type=script&lang=ts"
export * from "./PoultryDataForm.vue?vue&type=script&lang=ts"

import "./PoultryDataForm.vue?vue&type=style&index=0&id=b9fb2a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fb2a52"]])

export default __exports__